import React from 'react';
import { IntlFormatters } from 'react-intl';

interface MyProps {
  label: string;
  value: string;
  intl: IntlFormatters;
  classname: string;
  handleSortByChanged: (value: string) => void;
}

export class SortItem extends React.Component<MyProps> {
  constructor(props: MyProps) {
    super(props);
    this.handleSortByChanged = this.handleSortByChanged.bind(this);
  }

  render(): JSX.Element {
    const { intl: { formatMessage }, classname, label } = this.props;
    return (
      <div className={classname} onClick={this.handleSortByChanged}>
        {formatMessage({ id: label })}
      </div>
    );
  }

  private handleSortByChanged(): void {
    this.props.handleSortByChanged(this.props.value);
  }
}
